import axios from "axios";
import { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import "./AllCity.css";

const AllCity = () => {
  const [allStates, setAllStates] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [selectedState, setSelectedState] = useState("");

  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/states`)
      .then((resp) => setAllStates(resp.data))
      .catch((err) => console.error("Error fetching states:", err));
  }, []);

  const getAllCity = (stateId = "") => {
    const url = stateId
      ? `${API_BASE_URL}/cities/${stateId}`
      : `${API_BASE_URL}/cities`;

    axios
      .get(url)
      .then((resp) => {
        // Sort cities alphabetically by city name before setting state
        const sortedCities = [...(resp.data?.data || [])].sort((a, b) =>
          a.city.trim().localeCompare(b.city.trim())
        );
        setAllCities(sortedCities);
      })
      .catch((err) => console.error("Error fetching cities:", err));
  };

  useEffect(() => {
    getAllCity();
  }, []);

  const handleStateChange = (e) => {
    const stateId = e.target.value;
    setSelectedState(stateId);
    getAllCity(stateId);
  };

  const handleDelete = (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this city?"
    );
    if (confirmed) {
      axios
        .delete(`${API_BASE_URL}/admin/cities/${id}`, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then(() => {
          // Update city list after successful deletion
          setAllCities((prevCities) =>
            prevCities.filter((city) => city._id !== id)
          );
        })
        .catch((err) => console.error("Error deleting city:", err));
    }
  };

  return (
    <div id="filter-and-all-city-main">
      <div id="all-cities">
        <div className="all-cities-heading-div">
          <h4>All Cities</h4>
          <div className="all-cities-nav-btns-div">
            <button
              className="nav-add-cities-form"
              onClick={() => navigate("/create-city")}
            >
              Add City
            </button>
          </div>
        </div>

        <div id="all-cities-filter">
          <select value={selectedState} onChange={handleStateChange}>
            <option value="">--Select State--</option>
            {allStates.map((state) => (
              <option key={state._id} value={state._id}>
                {state.state}
              </option>
            ))}
          </select>
        </div>
        <div className=" w-100">
          <table className="w-75">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>City</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {allCities.length > 0 ? (
                allCities.map((city, idx) => (
                  <tr key={city._id}>
                    <td>{idx + 1}</td>
                    <td>{city.city}</td>
                    <td>
                      <div className="cities-action-icons">
                        <FaEdit
                          className="edit-cities-icon"
                          onClick={() => navigate(`/edit-city/${city._id}`)}
                        />
                        <MdDelete onClick={() => handleDelete(city._id)} />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2">No cities found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AllCity;
